import { FaRegMoneyBillAlt, FaUsers } from "react-icons/fa";
import { IoTicketOutline } from "react-icons/io5";
import { TbDeviceDesktopAnalytics } from "react-icons/tb";
import { LuUserCog } from "react-icons/lu";

export const menuData = [
  {
    link: "users",
    name: "Usuários",
    icon: FaUsers
  },
  {
    link: "invoice",
    name: "Faturamento",
    icon: TbDeviceDesktopAnalytics
  },
  {
    link: "payments",
    name: "Pagamentos",
    icon: FaRegMoneyBillAlt
  },
  {
    link: "tickets",
    name: "Tickets",
    icon: IoTicketOutline
  },
  {
    link: "userManager",
    name: "Gerenciar Usuários",
    icon: LuUserCog
  },
];
